import React from 'react';
import Cards from 'react-credit-cards';

import type { ICard } from './index';

export default function PreviewCard({ card }: { card: ICard }) {
  return (
    <Cards
      preview={true}
      cvc={card.cvc}
      expiry={card.expiry}
      name={card.name}
      number={card.number}
      issuer={card.issuer}
      locale={{ valid: 'Validade' }}
      placeholders={{ name: 'SEU NOME AQUI' }}
    />
  );
}
